document.getElementById("calc-button").onclick = function() {myFunction()};

function myFunction() {
  const width = document.getElementById('coverage-width');
  const height = document.getElementById('coverage-height');
  const nrCoats = document.getElementById('coverage-nr-coats');
  const coverage = document.getElementById('coverage-amount');
  const output = document.querySelector(".coverage-calculator__output");
  const outputNumber = document.querySelector(".coverage-calculator__output-number");
  
  let result = ((width.value * height.value) * coverage.value * nrCoats.value).toFixed(1) ;
  
  outputNumber.innerHTML = result;
  output.style.display = "flex";
 
}
